import React from "react"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"
import WPCta from "./_base/WPCta"

import { ChildSelector } from "../helpers/ChildSelector"

import * as testimonialStyles from "../styles/Testimonial.module.css"

export default function Testimonial(props) {
  const { content } = props

  const textStack = content.childNodes
    .filter(node => node.classNames === "testimonial-content")
    .map(t => t.text)

  const referenceStack = content.childNodes
    .filter(node => node.classNames === "reference-content")
    .map(t => t.text)

  const referenceName = ChildSelector.select(
    content,
    `reference-name`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const referenceCompany = ChildSelector.select(
    content,
    `reference-company`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )


  return (
    <div className={`${props.className} ${testimonialStyles.wrapper}`}>
      <div className={`row ${testimonialStyles.wrapperIntroText}`}>
        <div className={`col-12 ${testimonialStyles.content}`}>
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
      </div>
      <div className={`row ${testimonialStyles.wrapperSubject}`}>
        <div className={`col-12 ${testimonialStyles.content}`}>
          <WPImage
            holder={content}
            selector={`testimonial-avatar`}
            mode={DISPLAY_MODE.inline}
            className={`col-3 ${testimonialStyles.mediaAvatar}`}
          />
          <div className={`col-8 ${testimonialStyles.contentInformation}`}>
            <div className={`${testimonialStyles.author}`}>
              <p>{referenceName}</p>
            </div>
            <div className={`${testimonialStyles.position}`}>
              <p>{referenceStack}</p>
            </div>
            <div className={`${testimonialStyles.company}`}>
              <p>{referenceCompany}</p>
            </div>
            <div className={`row ${testimonialStyles.ctaWrapper}`}>
              <WPCta
                holder={content}
                selector={`testimonial-cta`}
                className={`${testimonialStyles.cta}`}
                pageContext={props.pageContext}
                modals={props.modals}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
